import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus } from "lucide-react";
import { toast } from "sonner";

export default function AddPersonnelDialog({ firmId, onClose, onDone }) {
  const [f, setF] = useState({ name: "", surname: "", duty: "", tc: "", birth_date: "", phone: "", status: "active", left_date: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async () => {
    if (!f.name.trim() || !f.surname.trim() || !f.duty.trim()) { toast.error("Ad, soyad ve görev zorunlu."); return; }
    setBusy(true);
    try {
      await api.post(`/firms/${firmId}/personnel`, {
        name: f.name.trim(), surname: f.surname.trim(), duty: f.duty.trim(),
        tc: f.tc.trim() || null, birth_date: f.birth_date || null, phone: f.phone.trim() || null,
        is_active: f.status === "active", left_date: f.status === "left" ? (f.left_date || null) : null,
      });
      toast.success("Personel eklendi."); onDone?.(); onClose();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader><DialogTitle className="font-display">Personel Ekle</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1"><Label className="text-xs">Ad*</Label><Input value={f.name} onChange={(e) => set("name", e.target.value)} data-testid="addp-name" /></div>
            <div className="space-y-1"><Label className="text-xs">Soyad*</Label><Input value={f.surname} onChange={(e) => set("surname", e.target.value)} data-testid="addp-surname" /></div>
          </div>
          <div className="space-y-1"><Label className="text-xs">Görev*</Label><Input value={f.duty} onChange={(e) => set("duty", e.target.value)} data-testid="addp-duty" /></div>
          <div className="grid grid-cols-3 gap-3">
            <div className="space-y-1"><Label className="text-xs">T.C. (ops.)</Label><Input value={f.tc} onChange={(e) => set("tc", e.target.value)} data-testid="addp-tc" /></div>
            <div className="space-y-1"><Label className="text-xs">Doğum Tarihi (ops.)</Label><Input type="date" value={f.birth_date} onChange={(e) => set("birth_date", e.target.value)} data-testid="addp-birth" /></div>
            <div className="space-y-1"><Label className="text-xs">Telefon (ops.)</Label><Input value={f.phone} onChange={(e) => set("phone", e.target.value)} data-testid="addp-phone" /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1"><Label className="text-xs">Çalışma Durumu</Label>
              <select className="border rounded px-2 py-2 text-sm w-full" value={f.status} onChange={(e) => set("status", e.target.value)} data-testid="addp-status">
                <option value="active">Çalışıyor</option>
                <option value="left">İşten ayrıldı</option>
              </select>
            </div>
            {f.status === "left" && (
              <div className="space-y-1"><Label className="text-xs">Ayrılma Tarihi (ops.)</Label><Input type="date" value={f.left_date} onChange={(e) => set("left_date", e.target.value)} data-testid="addp-left-date" /></div>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="addp-cancel">Vazgeç</Button>
          <Button className="bg-sky-600 hover:bg-sky-700" onClick={submit} disabled={busy} data-testid="addp-submit"><Plus className="h-4 w-4 mr-1" /> Ekle</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
